module.exports = __webpack_public_path__ + "bcb410dcdd3dd927ed6faf117d68e7ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_anna_mobile_teaser.jpg
// module id = 664
// module chunks = 0